/**
 * Created by lu on 2018/4/8.
 */
module.exports = function (inOpt) {
    var opts = inOpt || {};
    var success = opts.success;
    success.call(opts.scope, {

    });
};


//////////////////
// WEBPACK FOOTER
// ../src/js/io/product/order/getPageData.js
// module id = 686
// module chunks = 3